// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderTrackingNumberStyles } from "@steiner/App/Widgets/OrderDetails/OrderDetailsTrackingNumber";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

orderTrackingNumberStyles.wrapper = {
    ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
};

orderTrackingNumberStyles.titleText = {
    ...xOrderInformationStyles.headingAndTextStyles?.heading,
};

orderTrackingNumberStyles.orderTrackingNumberLink = {
    typographyProps: {
        variant: "h6",
        size: 14,
        lineHeight: "18px",
        weight: fontConfig.weight.semiBold,
        css: css`
            margin-bottom: 0;
            @media print {
                display: inline-block;
                width: auto;
            }
        `,
    },
};
